export const apiEndpointBaseUrl = `${import.meta.env.VITE_API_URL}/api`;
export const dataServiceBaseUrl = `${import.meta.env.VITE_API_URL}`;
export const wsServiceBaseUrl = `${import.meta.env.VITE_WEBSOCKET_URL}`;
